/**
 * Santa Eulalia - General Appointment Form (Tienda page)
 * Auto-generated asset uploaded via Shopify API.
 * v2.1 - Server-side validation with inline errors (CDN cache bump)
 * Do NOT edit directly in Shopify — changes will be overwritten on next publish.
 *
 * Handles #form-appointment with smart flatpickr:
 * - tailoring / groom sections → slot grid mode (uses groomConfig, like groom_form)
 * - other sections → simple mode (open/close times from hidden inputs)
 */
(function () {
  window.__appointmentFormV2 = true;

  function init() {
    if (typeof $ === 'undefined' || typeof flatpickr === 'undefined' || typeof Pristine === 'undefined') {
      setTimeout(init, 100);
      return;
    }

    var formEl = $('#form-appointment');
    if (!formEl.length) return;

    // --- helpers ---
    async function postData(url, data) {
      try {
        var response = await fetch(url, {
          method: 'POST', mode: 'cors', cache: 'no-cache', credentials: 'omit',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json;charset=utf-8', 'Access-Control-Allow-Origin': '*' },
          redirect: 'follow', referrerPolicy: 'no-referrer',
          body: JSON.stringify(data)
        });
        return await response.json();
      } catch (error) { console.log('postData error', error); }
    }

    function showServerError(msg) {
      var old = document.getElementById('server-error');
      if (old) old.remove();
      var el = document.createElement('div');
      el.id = 'server-error';
      el.className = 'pristine-error text-help';
      el.setAttribute('role', 'alert');
      el.style.display = 'block';
      el.style.marginTop = '8px';
      el.style.marginBottom = '8px';
      el.style.fontSize = '14px';
      el.textContent = msg;
      var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (submitBtn) {
        submitBtn.parentNode.insertBefore(el, submitBtn);
      } else {
        form.appendChild(el);
      }
    }

    function pad2(n) { return String(n).padStart(2, '0'); }

    function formatDate(d) {
      return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
    }

    // --- setup ---
    var form = document.getElementById('form-appointment');
    var pristine = new Pristine(form);
    var locale = typeof Shopify !== 'undefined' ? Shopify.locale : 'es';

    // Simple mode config from hidden inputs
    var closedDaysSimple = $('#appointment-info-hidde #not_available_appointment').val();
    var simpleMinTime = $('#appointment-info-hidde #open_appointment').val() || '10:00';
    var simpleMaxTime = $('#appointment-info-hidde #close_appointment').val() || '19:00';

    // Groom/slot mode config from window globals
    var groomConfig = window.groomConfig || null;
    var slotByDayConfig = window.groomSlotByDayConfig || null;

    // Slotted sections from config (extensible: any type with slot_group in DB)
    var SLOTTED_SECTIONS = (groomConfig && groomConfig.slottedSections) || ['groom'];

    // Closed days for slot mode
    var closedFromConfig = groomConfig && groomConfig.closed_days ? groomConfig.closed_days : [];
    var closedFromSimple = closedDaysSimple ? closedDaysSimple.split(',') : [];
    var allClosedDaysSlotted = closedFromConfig.concat(closedFromSimple).filter(function (v, i, a) { return a.indexOf(v) === i; });

    // Full days: dates where all appointment slots are taken
    var fullDaysSlotted = groomConfig && groomConfig.full_days ? groomConfig.full_days : [];

    // Full ranges: per-date list of time ranges that are fully booked
    var fullRangesSlotted = groomConfig && groomConfig.full_ranges ? groomConfig.full_ranges : {};

    // Current flatpickr instance
    var fpInstance = null;
    var currentMode = null; // 'simple' or 'slotted'

    // Slot grid elements
    var dateInputMain = document.getElementById('appointment-date');
    var dateInputPicker = document.getElementById('appointment-date-picker');
    var slotsWrapper = document.getElementById('appointment-slots-wrapper');
    var slotsGrid = document.getElementById('appointment-slots-grid');
    var selectedDate = null;
    var selectedTime = null;

    // --- helpers: get time ranges for a specific date (slot mode) ---
    function getRangesForDate(dateStr) {
      var d = new Date(dateStr + 'T12:00:00');
      var dayOfWeek = d.getDay();
      var isoDow = dayOfWeek === 0 ? 7 : dayOfWeek;

      var overrides = slotByDayConfig && slotByDayConfig.dateOverrides;
      var dateOverride = overrides ? overrides[dateStr] : null;
      if (dateOverride && dateOverride.closed) return [];

      return (dateOverride && dateOverride.timeRanges)
        || (groomConfig && groomConfig.timeRangesByWeekday && groomConfig.timeRangesByWeekday[isoDow])
        || [];
    }

    // --- Check if a time range is fully booked for a date ---
    function isRangeFull(dateStr, rangeStart, rangeEnd) {
      var dateFullRanges = fullRangesSlotted[dateStr];
      if (!dateFullRanges) return false;
      for (var i = 0; i < dateFullRanges.length; i++) {
        if (dateFullRanges[i].start === rangeStart && dateFullRanges[i].end === rangeEnd) {
          return true;
        }
      }
      return false;
    }

    // --- generate individual 15-min slots from ranges ---
    function generateSlots(dateStr, ranges) {
      var slots = [];
      var appointments = (groomConfig && groomConfig.currentAppointments) || {};

      for (var i = 0; i < ranges.length; i++) {
        var range = ranges[i];
        var rangeFull = isRangeFull(dateStr, range.start, range.end);
        var startParts = range.start.split(':');
        var endParts = range.end.split(':');
        var startMin = parseInt(startParts[0]) * 60 + parseInt(startParts[1]);
        var endMin = parseInt(endParts[0]) * 60 + parseInt(endParts[1]);

        for (var m = startMin; m < endMin; m += 15) {
          var hh = pad2(Math.floor(m / 60));
          var mm = pad2(m % 60);
          var time = hh + ':' + mm;
          var key = dateStr + ' ' + time;
          var occupied = appointments[key] || 0;
          var capacity = range.capacity != null ? range.capacity : 1;
          slots.push({
            time: time,
            label: hh + ':' + mm,
            available: !rangeFull && occupied < capacity
          });
        }
      }
      return slots;
    }

    // --- render slot grid ---
    function renderSlots(dateStr) {
      var ranges = getRangesForDate(dateStr);
      var slots = generateSlots(dateStr, ranges);

      slotsGrid.innerHTML = '';
      selectedTime = null;
      dateInputMain.value = '';

      // Clear any previous error
      var oldErr = document.getElementById('slot-error');
      if (oldErr) oldErr.remove();

      if (slots.length === 0) {
        slotsWrapper.style.display = 'none';
        return;
      }

      for (var i = 0; i < slots.length; i++) {
        (function (slot) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'groom-slot-btn' + (slot.available ? '' : ' disabled');
          btn.textContent = slot.label;
          btn.setAttribute('data-time', slot.time);
          if (!slot.available) {
            btn.disabled = true;
          }
          btn.addEventListener('click', function () {
            if (!slot.available) return;
            // Deselect previous
            var prev = slotsGrid.querySelector('.groom-slot-btn.active');
            if (prev) prev.classList.remove('active');
            // Select this
            this.classList.add('active');
            selectedTime = slot.time;
            dateInputMain.value = selectedDate + ' ' + selectedTime;
            // Clear any validation error
            var err = document.getElementById('slot-error');
            if (err) err.remove();
          });
          slotsGrid.appendChild(btn);
        })(slots[i]);
      }

      slotsWrapper.style.display = '';
    }

    // --- flatpickr: simple mode ---
    function createSimpleFlatpickr() {
      currentMode = 'simple';
      // Show main date input, hide date-only picker and slot grid
      dateInputMain.style.display = '';
      if (dateInputPicker) dateInputPicker.style.display = 'none';
      if (slotsWrapper) slotsWrapper.style.display = 'none';
      if (slotsGrid) slotsGrid.innerHTML = '';

      return flatpickr('#appointment-date', {
        locale: locale,
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        altInput: true,
        timeFormat: 'h:i K',
        altFormat: 'F j, Y. h:i K',
        minDate: new Date(Date.now() + 2 * 86400000),
        maxDate: new Date(Date.now() + 365 * 86400000),
        minuteIncrement: 15,
        disable: [
          function (date) {
            var dateStr = formatDate(date);
            // Sundays disabled
            if (date.getDay() === 0) return true;
            // Closed days from hidden input
            if (closedFromSimple.indexOf(dateStr) !== -1) return true;
            return false;
          }
        ],
        minTime: simpleMinTime,
        maxTime: simpleMaxTime
      });
    }

    // --- flatpickr: slotted mode (groom/tailoring) - date only + slot grid ---
    function createSlottedFlatpickr() {
      currentMode = 'slotted';
      selectedDate = null;
      selectedTime = null;

      // Hide main date input (will be used as hidden value), show date-only picker
      dateInputMain.style.display = 'none';
      dateInputMain.value = '';
      if (dateInputPicker) dateInputPicker.style.display = '';
      if (slotsWrapper) slotsWrapper.style.display = 'none';
      if (slotsGrid) slotsGrid.innerHTML = '';

      return flatpickr('#appointment-date-picker', {
        locale: locale,
        enableTime: false,
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'F j, Y',
        minDate: new Date(Date.now() + 2 * 86400000),
        maxDate: new Date(Date.now() + 62 * 86400000),
        disable: [
          function (date) {
            var dateStr = formatDate(date);
            if (allClosedDaysSlotted.indexOf(dateStr) !== -1) return true;
            if (fullDaysSlotted.indexOf(dateStr) !== -1) return true;

            var isoDow = date.getDay() === 0 ? 7 : date.getDay();
            var weekdaySlots = groomConfig && groomConfig.timeRangesByWeekday
              ? groomConfig.timeRangesByWeekday[isoDow] || []
              : [];
            var hasSlots = weekdaySlots.length > 0;

            var overrides = slotByDayConfig && slotByDayConfig.dateOverrides;
            var dateOverride = overrides ? overrides[dateStr] : null;
            if (dateOverride && dateOverride.closed === true) return true;

            // If override has timeRanges and ALL have capacity 0, treat as closed
            if (dateOverride && dateOverride.timeRanges && dateOverride.timeRanges.length > 0) {
              var allZero = dateOverride.timeRanges.every(function (r) { return r.capacity === 0; });
              if (allZero) return true;
            }

            return !hasSlots && !dateOverride;
          }
        ],
        onChange: function (selectedDates) {
          if (!selectedDates[0]) return;
          selectedDate = formatDate(selectedDates[0]);
          renderSlots(selectedDate);
        }
      });
    }

    // --- switch flatpickr mode based on section ---
    function switchMode(section) {
      var needSlotted = SLOTTED_SECTIONS.indexOf(section) !== -1;
      var targetMode = needSlotted ? 'slotted' : 'simple';

      if (currentMode === targetMode) return;

      // Destroy current instance
      if (fpInstance) {
        fpInstance.destroy();
        fpInstance = null;
      }

      // Clear values
      dateInputMain.value = '';
      if (dateInputPicker) dateInputPicker.value = '';

      // Recreate with correct mode
      if (targetMode === 'slotted') {
        fpInstance = createSlottedFlatpickr();
      } else {
        fpInstance = createSimpleFlatpickr();
      }
    }

    // --- detect section from radio buttons ---
    function getSelectedSection() {
      var sectionInput = form.querySelector('input[name="section"]:checked')
        || form.querySelector('select[name="section"]');
      if (sectionInput) return sectionInput.value;
      return form[4] ? form[4].value : '';
    }

    // --- initialize flatpickr based on current section ---
    var initialSection = getSelectedSection();
    if (SLOTTED_SECTIONS.indexOf(initialSection) !== -1) {
      fpInstance = createSlottedFlatpickr();
    } else {
      fpInstance = createSimpleFlatpickr();
    }

    // --- listen for section changes ---
    var sectionRadios = form.querySelectorAll('input[name="section"]');
    for (var i = 0; i < sectionRadios.length; i++) {
      sectionRadios[i].addEventListener('change', function () {
        switchMode(this.value);
      });
    }
    var sectionSelect = form.querySelector('select[name="section"]');
    if (sectionSelect) {
      sectionSelect.addEventListener('change', function () {
        switchMode(this.value);
      });
    }

    // --- submit handler ---
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Clear previous server error
      var oldServerError = document.getElementById('server-error');
      if (oldServerError) oldServerError.remove();

      var section = getSelectedSection();
      var isSlotted = SLOTTED_SECTIONS.indexOf(section) !== -1;

      // Slotted mode: validate date+time slot selected
      if (isSlotted) {
        var dateTimeVal = dateInputMain.value;
        if (!dateTimeVal || dateTimeVal.indexOf(' ') === -1) {
          var noSlotMsg = {
            ca: 'Selecciona si us plau una data i un horari.',
            es: 'Selecciona por favor una fecha y un horario.',
            en: 'Please select a date and a time slot.'
          };
          var old = document.getElementById('slot-error');
          if (old) old.remove();
          var errEl = document.createElement('div');
          errEl.id = 'slot-error';
          errEl.className = 'pristine-error text-help';
          errEl.style.display = 'block';
          errEl.style.marginTop = '4px';
          errEl.textContent = noSlotMsg[locale] || noSlotMsg.en;
          var pickerField = dateInputPicker ? dateInputPicker.closest('.field.form-group') : null;
          if (pickerField) {
            pickerField.appendChild(errEl);
          } else {
            dateInputMain.parentNode.insertAdjacentElement('afterend', errEl);
          }
          return;
        }

        // Capacity validation
        if (!validateSlotCapacity(dateTimeVal)) return;
      }

      // Pristine validation
      if (pristine.validate()) {
        var data = {
          locale: typeof Shopify !== 'undefined' ? Shopify.locale : 'es',
          name: form[0].value,
          lastname: form[1].value,
          email: form[2].value,
          phone: form[3].value,
          section: form[4].value,
          type: form[5].value,
          language: form[6].value,
          date: dateInputMain.value,
          comments: form[9].value
        };

        // Disable submit button while processing
        var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        postData('https://www.santaeulalia.com/apps/ereserve/store', data).then(function (result) {
          if (result && result.status === 'ok') {
            pristine.reset();
            form.reset();
            if (slotsWrapper) slotsWrapper.style.display = 'none';
            if (slotsGrid) slotsGrid.innerHTML = '';
            window.location.replace($('#appointment-info-hidde #appointment_success').val());
          } else if (result && result.status === 'error') {
            showServerError(result.message);
            if (submitBtn) submitBtn.disabled = false;
          } else {
            window.location.replace($('#appointment-info-hidde #appointment_error').val());
          }
        }).catch(function () {
          window.location.replace($('#appointment-info-hidde #appointment_error').val());
        });
      } else {
        // Terms checkbox validation
        var errorEl = document.getElementById('error-is_terms');
        if (errorEl) errorEl.remove();

        var termsCheckbox = document.getElementById('is_terms');
        if (termsCheckbox && !termsCheckbox.checked) {
          var node = document.querySelectorAll('.checkbox-label[for="is_terms"]');
          if (node.length) {
            var errorHtml = '<div class="pristine-error text-help" id="error-is_terms" role="alert">' + termsCheckbox.dataset.pristineRequiredMessage + '</div>';
            node[0].insertAdjacentHTML('afterend', errorHtml);
          }
        }
      }
    });

    // --- slot capacity validation (for slotted sections) ---
    function validateSlotCapacity(dateTimeVal) {
      if (!dateTimeVal || dateTimeVal.indexOf(' ') === -1) return true;

      var parts = dateTimeVal.split(' ');
      var dateVal = parts[0];
      var timeVal = parts[1];

      var dw = new Date(dateVal + 'T12:00:00').getDay();
      var isoDow = dw === 0 ? 7 : dw;

      var overrides = slotByDayConfig && slotByDayConfig.dateOverrides;
      var dateOverride = overrides ? overrides[dateVal] : null;
      var ranges = (dateOverride && dateOverride.timeRanges)
        || (groomConfig && groomConfig.timeRangesByWeekday && groomConfig.timeRangesByWeekday[isoDow])
        || [];

      var inRange = false;
      var slotCapacity = 0;
      var totalCapacity = 0;
      for (var j = 0; j < ranges.length; j++) {
        totalCapacity += ranges[j].capacity;
        if (timeVal >= ranges[j].start && timeVal < ranges[j].end) {
          inRange = true;
          slotCapacity = ranges[j].capacity;
        }
      }

      var appointments = (groomConfig && groomConfig.currentAppointments) || {};
      var totalOccupied = 0;
      var prefix = dateVal + ' ';
      for (var key in appointments) {
        if (key.indexOf(prefix) === 0) totalOccupied += appointments[key];
      }

      var outOfRangeMsg = {
        ca: "L'horari seleccionat no est\u00e0 disponible. Tria si us plau, una altra franja hor\u00e0ria.",
        es: 'El horario seleccionado no est\u00e1 disponible. Elige, por favor, otra franja horaria.',
        en: 'The selected time is not available. Please choose another time slot.'
      };
      var fullMsg = {
        ca: "L'horari que has seleccionat ja est\u00e1 reservat. Tria si us plau, una altra franja hor\u00e0ria.",
        es: 'El horario que has seleccionado ya est\u00e1 reservado. Elige, por favor, otra franja horaria.',
        en: 'The time slot you have selected is already booked. Please choose another time slot.'
      };

      function showSlotError(msg) {
        var old = document.getElementById('slot-error');
        if (old) old.remove();
        var el = document.createElement('div');
        el.id = 'slot-error';
        el.className = 'pristine-error text-help';
        el.setAttribute('role', 'alert');
        el.textContent = msg;
        var pickerField = dateInputPicker ? dateInputPicker.closest('.field.form-group') : null;
        if (pickerField) {
          pickerField.appendChild(el);
        } else {
          dateInputMain.parentNode.insertAdjacentElement('afterend', el);
        }
      }

      if (!inRange) {
        showSlotError(outOfRangeMsg[locale] || outOfRangeMsg.en);
        return false;
      }

      if (totalOccupied >= totalCapacity) {
        showSlotError(fullMsg[locale] || fullMsg.en);
        return false;
      }

      var slotKey = dateVal + ' ' + timeVal;
      var slotOccupied = appointments[slotKey] || 0;
      if (slotOccupied >= slotCapacity) {
        showSlotError(fullMsg[locale] || fullMsg.en);
        return false;
      }

      return true;
    }
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
